import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunbit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Logo/Sunbit/white",
	viewBox: "0 0 140 39.252",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "none",
				d: "M0 0h7.414v10.9H0Z",
				"data-name": "Clip 4"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "b",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "none",
				d: "M0 0h10.9v7.414H0Z",
				"data-name": "Clip 28"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "c",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "none",
				d: "M0 0h10.467v25.732H0Z",
				"data-name": "Clip 37"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		"data-name": "Group 45",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#3155a5",
				d: "M25.732 26.747c.007.014.008.03.015.044l4.5 8.574a.745.745 0 0 0 1.089.261 19.946 19.946 0 0 0 4.726-4.724.745.745 0 0 0-.261-1.09l-8.569-4.504c-.015-.006-.029-.007-.041-.012a9.371 9.371 0 0 1-1.459 1.451",
				"data-name": "Fill 1"
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 5",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M20.935 28.349h7.414v10.9h-7.414Z",
					"data-name": "Clip 4"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#a)",
					"data-name": "Group 5",
					transform: "translate(20.935 28.349)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#3155a5",
						d: "M.371.6 0 9.982a.876.876 0 0 0 .949.917 18.723 18.723 0 0 0 5.939-1.606.924.924 0 0 0 .386-1.324L2.361.057C2.349.037 2.333.019 2.319 0A8.828 8.828 0 0 1 .381.514.816.816 0 0 0 .371.6",
						"data-name": "Fill 3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3155a5",
				d: "m38.418 20.935-9.5.37c-.01.001-.022.007-.035.008a8.734 8.734 0 0 1-.534 1.928c.022.017.042.033.065.048l8.006 4.939a.812.812 0 0 0 1.158-.334 18.509 18.509 0 0 0 1.671-6.105.792.792 0 0 0-.831-.854",
				"data-name": "Fill 6"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3155a5",
				d: "M12.497 25.296c-.008.006-.025.007-.038.012l-8.57 4.504a.745.745 0 0 0-.261 1.09 19.944 19.944 0 0 0 4.722 4.724.744.744 0 0 0 1.089-.261l4.5-8.574c.007-.014.008-.03.015-.045a9.345 9.345 0 0 1-1.457-1.45",
				"data-name": "Fill 8"
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 12",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M10.903 28.349h7.414v10.9h-7.414Z",
					"data-name": "Clip 11"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#a)",
					"data-name": "Group 12",
					transform: "translate(10.903 28.349)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#3155a5",
						d: "M5.053.067.14 7.972a.922.922 0 0 0 .385 1.323 18.742 18.742 0 0 0 5.94 1.6.876.876 0 0 0 .948-.916L7.044.608a.735.735 0 0 0-.012-.089A8.87 8.87 0 0 1 5.1 0a.791.791 0 0 0-.05.067",
						"data-name": "Fill 10"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3155a5",
				d: "m10.332 21.306-9.497-.371a.792.792 0 0 0-.835.854 18.491 18.491 0 0 0 1.671 6.1.812.812 0 0 0 1.157.334l8.006-4.939a.594.594 0 0 0 .065-.048 8.751 8.751 0 0 1-.529-1.922c-.014 0-.025-.007-.038-.008",
				"data-name": "Fill 13"
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 17",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M20.935 0h7.414v10.9h-7.414Z",
					"data-name": "Clip 16"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#a)",
					"data-name": "Group 17",
					transform: "translate(20.935)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#f6931d",
						d: "m2.361 10.847 4.913-7.912a.924.924 0 0 0-.386-1.325A18.737 18.737 0 0 0 .949 0 .876.876 0 0 0 0 .921L.371 10.3a.827.827 0 0 0 .01.085 8.828 8.828 0 0 1 1.938.514c.014-.019.03-.037.042-.057",
						"data-name": "Fill 15"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f6931d",
				d: "M27.212 13.956h.011l8.578-4.507a.746.746 0 0 0 .261-1.091 19.986 19.986 0 0 0-4.73-4.732.746.746 0 0 0-1.087.263l-4.506 8.58c-.007.007-.007.015-.007.02a9.386 9.386 0 0 1 1.48 1.465",
				"data-name": "Fill 18"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f6931d",
				d: "m28.895 17.946 9.521.371a.793.793 0 0 0 .833-.854 18.469 18.469 0 0 0-1.676-6.105.815.815 0 0 0-1.16-.334l-8.025 4.939c-.014.008-.025.019-.039.029a8.728 8.728 0 0 1 .544 1.953",
				"data-name": "Fill 20"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f6931d",
				d: "M13.956 12.505c-.007-.014-.008-.03-.015-.043L9.439 3.889a.745.745 0 0 0-1.089-.263 19.96 19.96 0 0 0-4.724 4.725.745.745 0 0 0 .263 1.089l8.572 4.5c.012.007.026.007.038.012a9.4 9.4 0 0 1 1.459-1.452",
				"data-name": "Fill 22"
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 26",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M10.903 0h7.414v10.9h-7.414Z",
					"data-name": "Clip 25"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#a)",
					"data-name": "Group 26",
					transform: "translate(10.903)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#f6931d",
						d: "M7.043 10.3 7.414.92A.876.876 0 0 0 6.465 0 18.751 18.751 0 0 0 .526 1.6.923.923 0 0 0 .14 2.932l4.913 7.9a.832.832 0 0 0 .05.067 8.908 8.908 0 0 1 1.93-.52.837.837 0 0 0 .01-.088",
						"data-name": "Fill 24"
					})
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 29",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M0 10.903h10.9v7.414H0Z",
					"data-name": "Clip 28"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#b)",
					"data-name": "Group 29",
					transform: "translate(0 10.903)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#f6931d",
						d: "M10.838 5.06 2.833.121a.812.812 0 0 0-1.158.334A18.508 18.508 0 0 0 0 6.559a.792.792 0 0 0 .831.854l9.5-.371c.014 0 .025-.006.038-.007a8.729 8.729 0 0 1 .531-1.927.786.786 0 0 0-.065-.048",
						"data-name": "Fill 27"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M73.116 24.235a4.745 4.745 0 0 1-.979 3.087 3.3 3.3 0 0 1-2.8 1.208c-2.125 0-3.29-1.176-3.29-3.528v-10.33a.716.716 0 0 0-.713-.716h-3.682a.593.593 0 0 0-.593.592v11.22a7.934 7.934 0 0 0 .48 2.838 6.7 6.7 0 0 0 1.32 2.187 5.744 5.744 0 0 0 2.02 1.418 6.548 6.548 0 0 0 2.592.5c2.6 0 4.541-.71 5.823-2.75.015-.025.052-.118.052-.089v1.614a.726.726 0 0 0 .726.725h3.22a.775.775 0 0 0 .776-.774V14.749a.794.794 0 0 0-.794-.793h-3.415a.747.747 0 0 0-.748.747Z",
				"data-name": "Fill 30"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M110.433 32.274c-2.5 0-4.179-.832-5.272-2.618l-.027 1.5a.624.624 0 0 1-.619.612h-3.584a.621.621 0 0 1-.619-.62V6.729a.622.622 0 0 1 .619-.623h3.688a.621.621 0 0 1 .618.623v8.465a5.333 5.333 0 0 1 2.78-1.928 9.418 9.418 0 0 1 2.839-.436 7.34 7.34 0 0 1 3.291.716 6.937 6.937 0 0 1 2.443 2.034 9.454 9.454 0 0 1 1.52 3.118 10.175 10.175 0 0 1 .52 3.351 13.958 13.958 0 0 1-.616 4.3 9.83 9.83 0 0 1-1.693 3.215 7.235 7.235 0 0 1-2.6 2.013 7.84 7.84 0 0 1-3.288.697m-.771-15.281a4.259 4.259 0 0 0-3.27 1.392 6.138 6.138 0 0 0-1.347 4.176 6.569 6.569 0 0 0 1.213 4.1 3.741 3.741 0 0 0 3.021 1.511 4.036 4.036 0 0 0 3.286-1.607 5.283 5.283 0 0 0 .86-1.763 8.324 8.324 0 0 0 .264-2.238 6.427 6.427 0 0 0-1.322-4.258 3.611 3.611 0 0 0-2.705-1.313",
				"data-name": "Fill 32"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M121.063 32.274h3.42a.7.7 0 0 0 .691-.718V14.674a.7.7 0 0 0-.691-.718h-3.42a.7.7 0 0 0-.689.718v16.882a.7.7 0 0 0 .689.718",
				"data-name": "Fill 34"
			}),
			/* @__PURE__ */ _jsxs("g", {
				"data-name": "Group 38",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M127.788 6.542h10.467v25.732h-10.467Z",
					"data-name": "Clip 37"
				}), /* @__PURE__ */ _jsx("g", {
					clipPath: "url(#c)",
					"data-name": "Group 38",
					transform: "translate(127.788 6.542)",
					children: /* @__PURE__ */ _jsx("path", {
						fill: "#191d63",
						d: "M10.467 21.835a.873.873 0 0 0-.883-.864l-2.041.008c-3.247 0-2.518-3.362-2.518-6.078v-3.144h3.656a.872.872 0 0 0 .881-.864V8.1a.872.872 0 0 0-.881-.863H5.025V.864A.872.872 0 0 0 4.145 0H.887a.873.873 0 0 0-.881.864v17.254c0 1.026-.491 7.614 7.459 7.614.171 0 .338 0 .5-.009h1.621a.873.873 0 0 0 .881-.864Z",
						"data-name": "Fill 36"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M125.608 8.505a2.835 2.835 0 1 1-2.835-2.835 2.835 2.835 0 0 1 2.835 2.835",
				"data-name": "Fill 39"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M85.202 21.995a4.745 4.745 0 0 1 .979-3.087 3.511 3.511 0 0 1 2.9-1.208q3.187 0 3.187 3.528v10.33a.716.716 0 0 0 .717.716h3.681a.592.592 0 0 0 .593-.592v-11.22a7.932 7.932 0 0 0-.48-2.842 6.707 6.707 0 0 0-1.325-2.186 5.761 5.761 0 0 0-2.016-1.414 6.556 6.556 0 0 0-2.589-.5 6.412 6.412 0 0 0-5.825 3.061.028.028 0 0 1-.052-.014v-1.823a.726.726 0 0 0-.723-.724h-3.224a.776.776 0 0 0-.776.774V31.48a.8.8 0 0 0 .8.794h3.4a.747.747 0 0 0 .748-.747Z",
				"data-name": "Fill 41"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#191d63",
				d: "M51.536 32.274a11.076 11.076 0 0 1-4.512-.875 7.681 7.681 0 0 1-3.1-2.379 6.274 6.274 0 0 1-1.177-2.677.388.388 0 0 1 .381-.458h4.813a.388.388 0 0 1 .371.282 2.55 2.55 0 0 0 .949 1.354 3.565 3.565 0 0 0 2.209.685 3.16 3.16 0 0 0 1.869-.486 1.582 1.582 0 0 0 .707-1.337 1.542 1.542 0 0 0-1.007-1.463 18.074 18.074 0 0 0-2.9-.924 26.49 26.49 0 0 1-3.51-1.045 5.924 5.924 0 0 1-2.359-1.689 4.607 4.607 0 0 1-.973-3.089 5.331 5.331 0 0 1 .9-3 6.134 6.134 0 0 1 2.669-2.161 10.313 10.313 0 0 1 4.246-.8 8.464 8.464 0 0 1 5.715 1.806 6.915 6.915 0 0 1 2.286 4.1.373.373 0 0 1-.078.3.388.388 0 0 1-.3.146h-4.41a.388.388 0 0 1-.376-.271 2.6 2.6 0 0 0-.885-1.326 3.318 3.318 0 0 0-2.129-.655 2.95 2.95 0 0 0-1.746.45 1.528 1.528 0 0 0-.654 1.3 1.577 1.577 0 0 0 1.023 1.48 14.546 14.546 0 0 0 2.853.872 30.455 30.455 0 0 1 3.538 1.115 5.986 5.986 0 0 1 2.34 1.726 4.9 4.9 0 0 1 1.026 3.165 5.082 5.082 0 0 1-.932 2.993 6.253 6.253 0 0 1-2.7 2.088 10.439 10.439 0 0 1-4.143.769",
				"data-name": "Fill 43"
			})
		]
	})]
});
export default SvgSunbit;
